// src/plugins/AlertBus.js
import Vue from 'vue';
export const AlertBus = new Vue();